/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Email_For_ResetInputs */

const en_enter_email_for_reset = /** @type {(inputs: Enter_Email_For_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email and we'll send you a link to reset your password.`)
};

const nl_enter_email_for_reset = /** @type {(inputs: Enter_Email_For_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer je e-mailadres in en we sturen je een link om je wachtwoord opnieuw in te stellen.`)
};

/**
* | output |
* | --- |
* | "Enter your email and we'll send you a link to reset your password." |
*
* @param {Enter_Email_For_ResetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const enter_email_for_reset = /** @type {((inputs?: Enter_Email_For_ResetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Email_For_ResetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_enter_email_for_reset(inputs)
	return en_enter_email_for_reset(inputs)
});